import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Product } from '../shared/interfaces/product';
import { CartItem } from '../shared/interfaces/cart-item';
import { BehaviorSubject, Observable, Subject, timer } from 'rxjs';
import { map } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';

import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { DataService } from 'src/app/services/data.service';



@Injectable({
    providedIn: 'root'
})
export class BillingService {
   
  private baseUrl = environment.apiBaseUrl;
  public menuByRoleId$: BehaviorSubject<any> = new BehaviorSubject(null)

 
    constructor(
        private http: HttpClient,
    private dataService: DataService,
    ) {
       
    }
    getInvoiceList(referenceNumber: any, refresh: Boolean)
    {
      return this.dataService.getData('/api/Application/getCustomerInvoice/' + referenceNumber, refresh);
    }

    getBalance(referenceNumber: any, refresh: Boolean)
    {
      return this.dataService.getData('/api/Application/getCustomerBillingBalance/' + referenceNumber, refresh);
    }

    generateStatement(data) {
        
        return this.dataService.post('/api/Report/getCustomerStatementReceiptReport', data);
    }
    getMailingStateType() {
      return this.http.get(`${this.baseUrl}/api/lookup/getMailingStateTypeList`);
    }
    getBillingRoleType() {
      return this.http.get(`${this.baseUrl}/api/lookup/getBillingRoleTypeList`);
    }
    getUserBilling() {
      return this.http.get(`${this.baseUrl}/api/lookup/getUserBilling`);
    }
    submitUserBilling(data) {
      return this.dataService.post('/api/Report/submitUserBilling', data)
    }
}
